import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;


export function PDFViewer(file:File | null | undefined, size:number = 300) {
    return(
        <>
            <Document file={file}>
                <Page pageNumber={1} width={size}/>
            </Document>
        </>
    )
}